import { createComponent } from '@carvana/merch-components';

export const SortInventoryModalWrapper = createComponent('div', {
  className: `
    absolute
    bg-white
    rounded
    text-blue-2
    w-[185px]
    top-[30px]
    right-0
    py-20
    px-8
    shadow-[1px_2px_3px_1px_rgba(25,41,61,0.18)]
    text-xs
    z-[13]
    before:block
    before:content-['']
    before:border-x-8
    before:border-x-transparent
    before:border-b-8
    before:border-b-white
    before:absolute
    before:top-[-7px]
    before:right-[14px]
    before:m:right-[calc(50%-3.5px)]
  `,
  'data-qa': 'sort-inventory-modal-wrapper'
});

export const InventoryListItemWrapper = createComponent('div', {
  className: 'gap-x-4 grid grid-cols-[14px_1fr] items-center justify-start'
});

export const InventoryListButton = createComponent('button', {
  className:
    'bg-transparent border-0 disabled:text-blue-2 hover:text-blue-2 px-0 py-8 text-blue-6 text-left tl-label-s'
});
